import {Injectable} from '@angular/core';

import { ActivatedRouteSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {TrackingResultService} from "../service/tracking-result.service";
import {TrackingResponse} from "../entities";


@Injectable({
  providedIn: 'root',
})
export class TrackingResultResolver  {
  constructor(private trackingResultService: TrackingResultService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<TrackingResponse> {
    const searchString = route.params["searchString"];
    return this.trackingResultService.search(searchString);
  }
}
